var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.66 7.25981C20.66 7.18981 20.56 7.11981 20.51 7.04981L20.42 6.94981C20.1872 6.6623 19.8934 6.43005 19.56 6.26981L13.16 3.26981C12.8057 3.10653 12.4201 3.02197 12.03 3.02197C11.6399 3.02197 11.2543 3.10653 10.9 3.26981L4.5 6.26981C4.16826 6.43277 3.87507 6.66459 3.64 6.94981L3.52 6.99981C3.46183 7.05994 3.41144 7.12713 3.37 7.19981C3.13144 7.57702 3.00326 8.0135 3 8.45981V15.5198C3.00134 15.9968 3.13964 16.4633 3.39847 16.864C3.65729 17.2646 4.02574 17.5825 4.46 17.7798L10.86 20.7798C11.2157 20.9446 11.603 21.03 11.995 21.03C12.387 21.03 12.7743 20.9446 13.13 20.7798L19.53 17.7798C19.9631 17.5854 20.3315 17.2712 20.592 16.8744C20.8524 16.4775 20.994 16.0145 21 15.5398V8.45981C20.9949 8.03677 20.8775 7.62267 20.66 7.25981V7.25981ZM11.71 5.05981C11.8015 5.02018 11.9002 4.99974 12 4.99974C12.0998 4.99974 12.1985 5.02018 12.29 5.05981L17.62 7.53981L12 10.1498L6.38 7.53981L11.71 5.05981ZM5.3 15.9998C5.21293 15.966 5.1379 15.9071 5.08447 15.8305C5.03104 15.7539 5.00163 15.6632 5 15.5698V9.09981L11 11.8898V18.6098L5.3 15.9998ZM18.69 15.9998L13 18.6098V11.8898L19 9.09981V15.5398C19.0023 15.6391 18.9737 15.7367 18.9182 15.8191C18.8626 15.9015 18.7829 15.9646 18.69 15.9998Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 1H21C22.1046 1 23 1.89543 23 3V5",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5L1 3C1 1.89543 1.89543 1 3 1L5 1",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 23H21C22.1046 23 23 22.1046 23 21V19",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19L1 21C1 22.1046 1.89543 23 3 23L5 23",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.e96e92c42a99c2837bee84331c79b775.svg";
export { ForwardRef as ReactComponent };